// extracted by css-extract-rspack-plugin
export default {"root":"root-xgz2fa","button":"button-pwKzku","tip":"tip-Zk4DEh","heading":"heading-HWLRYw","line":"line-tAsHRu"};